var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "location_statte" }, [
    _c("div", { staticClass: "last_state mt-1" }, [
      _c("span", { class: _vm.get_state_class }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }